import axios from 'axios'
const DOBBY_URL = process.env.REACT_APP_DOBBY_URL

export const getMetaData = (type) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${DOBBY_URL}/api/v1/metadata/${type}`,
    })

    return res.data
  } catch (error) {
    return error.data
  }
}

export const updateMetaData = (type, metadataId, data) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'put',
      url: `${DOBBY_URL}/api/v1/metadata/${type}?metadata_id=${metadataId}`,
      data: data,
    })

    return res.data
  } catch (error) {
    return error.data
  }
}
export const createMetaData = (type, data) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'post',
      url: `${DOBBY_URL}/api/v1/metadata/${type}`,
      data: data,
    })

    return res.data
  } catch (error) {
    return error.data
  }
}

export const getCategoriesAction = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${DOBBY_URL}/api/v1/metadata/system`,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}
